import type { ActivityContentMessageArchiving } from "@/api";
import type { Activity } from "@/models/activities";

import React from "react";
import { Link } from "react-router";
import { Trans } from "../i18n";
import { activityAuthorName } from "../feedItemLinks";
import type { ActivityHandler, FeedItemProps } from "../interfaces";

const MessageArchiving: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(_paths, _activity: Activity) {
    throw new Error("Not implemented");
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page, paths }: FeedItemProps) {
    const title = content(activity).title!;
    const space = content(activity).space!;
    const spaceLink = <Link to={paths.spacePath(space.id!)}>{space.name!}</Link>;

    if (page === "space") {
      return <Trans i18nKey="{{author}} deleted: {{title}}" values={{ author: activityAuthorName(activity), title }} />;
    } else {
      return (
        <Trans
          i18nKey="{{author}} deleted: {{title}} from <space>{{spaceName}}</space>"
          values={{ author: activityAuthorName(activity), title, spaceName: space.name }}
          components={{ space: spaceLink }}
        />
      );
    }
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_props: { activity: Activity }) {
    return "";
  },

  NotificationLocation(_props: { activity: Activity }) {
    return null;
  },
};

function content(activity: Activity): ActivityContentMessageArchiving {
  return activity.content as ActivityContentMessageArchiving;
}

export default MessageArchiving;
